// Package imports:
import React from 'react';
// Component imports:
import Entrypoint from '../Entrypoint';
import CompanySubPage from '../../components/Company/CompanySubPage/CompanySubPage';
import ViewCompanyCompare from '../../components/Company/CompanyCompare/ViewCompanyCompare';
// Type imports:
import { ICompanyViewModel } from '../../types/CompanyTypes';

const ViewCompanyComparePage: React.FC<ICompanyViewModel & {eventId: string}> = ({
    id,
    eventId,
    isAuthenticated,
    isSubscriber
}) => {
    return (
        <Entrypoint>
            <CompanySubPage
                noAd
                id={id}
                title='Samanburður'
                isAuthenticated={isAuthenticated}
                isSubscriber={isSubscriber}
                component={
                    <ViewCompanyCompare id={id} eventId={eventId} />
                } 
                />
        </Entrypoint>
    );
}

export default ViewCompanyComparePage;